export interface ICreds {
  userName: string;
  userToken: string;
  error?: string;
}

export interface IMember {
  memberFirstName: IFieldData;
  memberLastName: IFieldData;
  memberRole?: IFieldData;
  email: IFieldData;
}

export interface ISendMember {
  firstName: string;
  lastName: string;
  memberRole?: string;
  email: string;
}

export interface IMembersData {
  name: string;
  email: string;
  role: string;
}

export interface IResetPassword {
  resetPasswordUser: IFieldData;
  resetPasswordPopupStatus: boolean;
}

export interface IPopupData {
  title: string;
  description: string;
  status: MembersPopupType | DeleteAllDataPopupType | string;
}

export interface IWebhook {
  key: string;
  url: string;
  environment: Environments;
}

export enum Environments {
  prod = 'PRODUCTION',
  sandbox = 'SANDBOX',
}

export interface Ikeys {
  sunbitKey: string;
  secretKey: string;
  environment: Environments;
}

export interface IFieldData {
  fieldName?: string;
  value: string;
  error: string;
}

export interface ITrack {
  eventName: string;
  props: any
}

export interface IFieldChangeData {
  value: string;
  fieldName: string;
  passValidation?: boolean;
  payload?: object | any;
}

export interface ISignIn {
  userName: IFieldData;
  password: IFieldData;
  confirmPassword: IFieldData;
  signInPopup: IPopupData;
}

export enum MembersPopupType {
  addMember = 'addMember',
  addMemberSuccess = 'addMemberSuccess',
  addMemberFail = 'addMemberFail',
}

export enum DeleteAllDataPopupType {
  deleteAllData = 'deleteAllData',
  deleteAllDataSuccess = 'deleteAllDataSuccess',
  deleteAllDataFail = 'deleteAllDataFail',
}

export interface IAllianceData {
  userFirstName: string;
  userLastName: string;
  allianceName: string;
  userRole: string;
}

export enum TestWebhooksPopupType {
  testWebhookSuccess = 'testWebhookSuccess',
  testWebhookFail = 'testWebhookFail',
}

export enum signInPopupType {
  signInFail = 'signInFail',
  signInLocked = 'signInLocked',
  resetPasswordFailedLocked = 'resetPasswordFailedLocked',
  resetPasswordFailedGeneral = 'resetPasswordFailedGeneral',
  resetPasswordSuccess = 'resetPasswordSuccess',
}

export enum EnvironmentStatus {
  INITIAL = 'INITIAL',
  ENABLED = 'ENABLED',
  REQUEST_PENDING = 'REQUEST_PENDING',
}

export interface IEnvironmentStatus {
  status: EnvironmentStatus;
  name: Environments;
}

export interface IEnvironmentsStatusResponse {
  environments: IEnvironmentStatus[];
}
